import RocketIcon from 'shared/icons/rocket.svg';
import TargetIcon from 'shared/icons/target.svg';
import ShieldIcon from 'shared/icons/shield.svg';
import { GosuslugiButton } from './gosuslugi-button';
import styles from './gosuslugi.module.scss';
import { GosuslugiCard, OutlineButton } from './';

type GosuslugiProps = {
  onEsiaRedirectAction: () => void;
  isLoading?: boolean;
  className?: string;
};

export const Gosuslugi = ({ onEsiaRedirectAction, isLoading }: GosuslugiProps) => {
  const scrollToForm = () => {
    document.querySelector('#questionnaire-form')?.scrollIntoView({
      behavior: 'smooth',
    });
  };

  return (
    <div className={styles.gosuslugi}>
      <div className={styles.backgroundFiller}>
        <div className={styles.content}>
          <div className={styles.header}>
            Заполните анкету для{'\u00A0'}трудоустройства через{'\u00A0'}
            Госуслуги!
          </div>
          <div className={styles.buttons}>
            <GosuslugiButton className={styles.gosuslugiButton} disabled={isLoading} onClick={onEsiaRedirectAction} />
            <OutlineButton className={styles.byHandButton} onClick={scrollToForm}>
              Заполнить{'\u00A0'}вручную
            </OutlineButton>
          </div>
        </div>
      </div>
      <div className={styles.cards}>
        <GosuslugiCard title="Быстро" description="все данные заполнятся автоматически" iconSrc={RocketIcon} />
        <GosuslugiCard title="Точно" description="исключены ошибки ручного ввода" iconSrc={TargetIcon} />
        <GosuslugiCard
          title="Безопасно"
          description="ваши данные защищены и не передаются третьим лицам"
          iconSrc={ShieldIcon}
        />
      </div>
    </div>
  );
};
